import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {CockpitCard} from 'shared/dtos/cockpit-card';
import {ChartsDurchschnittlicherBeschaeftigungsgrad} from 'shared/dtos/cockpit/charts/chartsDurchschnittlicherBeschaeftigungsgrad';
import {SeriesAbsolutPerc} from 'shared/dtos/cockpit/charts/seriesAbsolutPerc';
import {Cockpit} from 'shared/dtos/cockpit/cockpit';
import {
  AnzahlMitarbeitendeNachGrungesamtheit,
  Personalbestand
} from 'shared/dtos/cockpit/personalbestand';
import {DataStorageService} from 'shared/services/data-storage.service';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';
import {CockpitContentComponent} from '../../cockpit-content-component';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';

@Component({
  selector: 'app-cart-dialog-personalbestand',
  templateUrl: './cart-dialog-personalbestand.component.html',
  styleUrls: [
    '../../../cockpit-shared/contents/cockpit-styles.scss',
    './cart-dialog-personalbestand.component.scss'
  ],
  standalone: false
})
export class ChartDialogPersonalbestandComponent
  extends CurrentLocaleComponent
  implements OnInit, CockpitContentComponent
{
  card: CockpitCard;
  chart: Highcharts.Chart;

  tableHeaders = [
    'm1-m2.sprint8.cockpit.card.chart.personalbestand.anzahlMitarbeitendeGrundgesamtheit.title',
    'i18n.cockpit.card.chart.personalbestand.mitarbeitende.title',
    'i18n.cockpit.card.chart.personalbestand.durschnittlicherBeschäftigungsgrad'
  ];

  personalbestand: Personalbestand;
  seriesAnzahlAnteilMitarbeitende: SeriesAbsolutPerc;
  durchschnittlicherBeschaeftigungsgrad: ChartsDurchschnittlicherBeschaeftigungsgrad;
  anzahlMitarbeitendeNachGrundgesamtheit: AnzahlMitarbeitendeNachGrungesamtheit;

  constructor(
    private readonly storage: DataStorageService,
    private readonly tableExport: TableExportService,
    protected readonly translate: TranslateService
  ) {
    super(translate);
  }

  async ngOnInit() {
    super.ngOnInit();
    const chartData = await this.storage.getChartsData();
    this.seriesAnzahlAnteilMitarbeitende =
      chartData.personalbestand.anzahlMitarbeitende;
    this.durchschnittlicherBeschaeftigungsgrad =
      chartData.personalbestand.durchschnittlicherBeschaeftigungsgrad;

    const cockpitData = await this.storage.getCockpitData();
    this.personalbestand = (cockpitData as Cockpit).personalbestand;
    this.anzahlMitarbeitendeNachGrundgesamtheit =
      this.personalbestand.anzahlMitarbeitendeNachGrundgesamtheit;
  }

  exportChart() {
    this.chart.exportChart(
      {
        type: 'application/pdf',
        filename: 'my-pdf'
      },
      {}
    );
  }

  exportTable(id: string, headerIndex: number) {
    this.tableExport.exportHtmlTable(id, this.tableHeaders[headerIndex]);
  }
}
